<app-dropdown-select
	[tooltip]="control.valid ? 'Listing Status' : 'Required'"
	[control]="control"
	[options]="listingStatusOptions"
	[label]="'Status'"
	[pluralLabel]="'Statuses'"
	[multiple]="true"
	[dropdownToggleClass]="control.valid ? '' : 'text-danger'"
	dropdownMenuClass="checkbox-dropdown"
></app-dropdown-select>
